import { LoaderFunctionArgs } from 'react-router'
import { queryClient } from '@/api/client'
import { unitSettingsQueryOptions } from '../../cogs/api'
import { LoaderResponse } from '@/types'

type OWCConfig = {
  currentAssets: any | null
  currentLiabilities: any | null
  taxes: any | null
}

export const owcLoader = async ({ params }: LoaderFunctionArgs) => {
  const { id: financialModelId } = params
  if (!financialModelId) {
    return {
      cogsGranularity: null
    }
  }

  const owcConfig: OWCConfig = {
    currentAssets: null,
    currentLiabilities: null,
    taxes: null
  }

  const cogsSettings = await queryClient.ensureQueryData(unitSettingsQueryOptions(financialModelId))

  // TODO: Add specific OWC API calls and configuration logic
  // This is a placeholder structure that follows the TWC pattern

  const cogsGranularity = cogsSettings.level_of_granularity
  return {
    cogsGranularity,
    ...owcConfig
  }
}

export type OwcLoaderResponse = LoaderResponse<typeof owcLoader>
